import * as Yup from "yup";
import { specialCharactersNotAllowedValidation } from "../../../helpers/constants/commonValidationSchemaUtils";
import { KeyValueMap } from "../../../redux/slices/appState/models";
import { CreateBulkActivityFormKey, SearchParticipantFormKey } from "./Models";

export const BulkActivitySearchParticipantSchema = () =>
  Yup.object().shape({
    [SearchParticipantFormKey.participantName]: Yup.string().default(""),
    [SearchParticipantFormKey.participantNameFilter]: Yup.string().default(""),
    [SearchParticipantFormKey.programName]: Yup.string().default(""),
    [SearchParticipantFormKey.programNameFilter]: Yup.string().default(""),
    [SearchParticipantFormKey.clientName]: Yup.string().default(""),
    [SearchParticipantFormKey.clientNameFilter]: Yup.string().default(""),
    [SearchParticipantFormKey.programTemplate]: Yup.array().default([]),
    [SearchParticipantFormKey.deliveryCountry]: Yup.string().default(""),
    [SearchParticipantFormKey.deliveryOffice]: Yup.string().default(""),
    [SearchParticipantFormKey.deliveryOfficeFilter]: Yup.string().default(""),
    [SearchParticipantFormKey.coach]: Yup.string().default(""),
    [SearchParticipantFormKey.coachFilter]: Yup.string().default(""),
    [SearchParticipantFormKey.status]: Yup.string().default(""),
    [SearchParticipantFormKey.productLine]: Yup.string().default(""),
    [SearchParticipantFormKey.createdDate]: Yup.string().default(""),
  });

export const CreateBulkActivitySchema = (
  commonValidationMessages: KeyValueMap,
) =>
  Yup.object().shape({
    [CreateBulkActivityFormKey.bulkProcessName]:
      specialCharactersNotAllowedValidation(
        commonValidationMessages.requiredValidation,
        commonValidationMessages.fieldContainsInvalidCharactersErrorMessage,
      ).default(""),
  });
